import request from '@/utils/request'

// 查询列表
export function apiEmployeeList(query) {
  return request({
    url: '/bom/employee/list',
    method: 'get',
    params: query
  })
}

// 修改
export function apiEmployeeUpdate (data) {
  return request({
    url: '/bom/employee/save',
    method: 'post',
    data: data
  })
}

// 导出列表
export function apiEmployeeExport (data) {
  return request({
    url: '/bom/employee/export',
    method: 'post',
    data: data
  })
}

// 删除
export function apiEmployeeDel (id) {
  return request({
    url: '/bom/employee/remove',
    method: 'post',
    data: id
  })
}
